import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.1_713fb40cf4b231dfcf16506806954d9c/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}